import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "items-view" }
const _hoisted_2 = { class: "items-view__header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "items-view__ex" }, null, -1)
const _hoisted_4 = {
  key: 1,
  class: "items-view__empty"
}
const _hoisted_5 = { class: "items-view__loading" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SortDropdown = _resolveComponent("SortDropdown")!
  const _component_NButton = _resolveComponent("NButton")!
  const _component_CameraShotAttach = _resolveComponent("CameraShotAttach")!
  const _component_RemoteDailyEventItem = _resolveComponent("RemoteDailyEventItem")!
  const _component_Confidence = _resolveComponent("Confidence")!
  const _component_CaseClusterItem = _resolveComponent("CaseClusterItem")!
  const _component_ObjectItem = _resolveComponent("ObjectItem")!
  const _component_NAttachments = _resolveComponent("NAttachments")!
  const _component_NLoadingCircle = _resolveComponent("NLoadingCircle")!
  const _component_InfiniteScroll = _resolveComponent("InfiniteScroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.sortTypes && _ctx.items.length)
        ? (_openBlock(), _createBlock(_component_SortDropdown, {
            key: 0,
            items: _ctx.sortTypes,
            modelValue: _ctx.module.filter.current.ordering,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.module.filter.current.ordering) = $event))
          }, null, 8, ["items", "modelValue"]))
        : _createCommentVNode("", true),
      _hoisted_3,
      (_ctx.uploadFeature && _ctx.modelAcl.add)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_NButton, {
              icon: "upload",
              type: "secondary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('action', 'upload-file')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('cards.upload_photos','f')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_CameraShotAttach, { onAttach: _ctx.attachHandler }, null, 8, ["onAttach"])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (_ctx.items.length)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["items-view__body", _ctx.bodyClasses])
        }, [
          (_ctx.locations)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.items, (item) => {
                return (_openBlock(), _createBlock(_component_RemoteDailyEventItem, {
                  type: "short",
                  key: item.id,
                  item: item,
                  onShowImage: _ctx.showImage
                }, null, 8, ["item", "onShowImage"]))
              }), 128))
            : (_ctx.matchedCaseClusters || _ctx.relatedCaseClusters)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.items, (item) => {
                  return (_openBlock(), _createBlock(_component_CaseClusterItem, {
                    key: item.id,
                    item: item,
                    "show-case": true,
                    "show-name": true,
                    "show-role": true,
                    "show-events-count": true,
                    "show-confidence": false,
                    "show-card": false,
                    onAction: (type) => _ctx.caseClusterActionHandler(type, item),
                    onCaseClick: ($event: any) => (_ctx.caseClickHandler(item))
                  }, {
                    thumbnailConfidence: _withCtx(() => [
                      _createVNode(_component_Confidence, {
                        type: "number",
                        objects: "faces",
                        align: "left",
                        value: _ctx.getCaseClusterConfidence(item)
                      }, null, 8, ["value"])
                    ]),
                    _: 2
                  }, 1032, ["item", "onAction", "onCaseClick"]))
                }), 128))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.items, (item) => {
                  return (_openBlock(), _createBlock(_component_ObjectItem, {
                    key: item.id,
                    item: item,
                    acl: _ctx.modelAcl,
                    onAction: _cache[2] || (_cache[2] = (v, p) => _ctx.$emit('action', v, p))
                  }, null, 8, ["item", "acl"]))
                }), 128))
        ], 2))
      : (!_ctx.module.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_ctx.uploadFeature && _ctx.modelAcl.add)
              ? (_openBlock(), _createBlock(_component_NAttachments, {
                  key: 0,
                  onAttach: _ctx.handleDndAttach,
                  accept: "image/*",
                  class: "user-photos__dnd",
                  "disallow-attach": "",
                  drag: "",
                  "hide-amount": ""
                }, {
                  droparea: _withCtx(() => [
                    _createElementVNode("label", null, _toDisplayString(_ctx.$t('common.drag_and_drop_files')), 1),
                    _createElementVNode("div", {
                      onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      _createVNode(_component_NButton, {
                        icon: "upload",
                        type: "secondary",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('action', 'upload-file')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('cards.upload_photos','f')), 1)
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('common.or')) + " ", 1),
                      _createVNode(_component_CameraShotAttach, {
                        onAttach: _ctx.attachHandler,
                        type: "link",
                        icon: "",
                        i18n_label: "common.uploader_activate_webcam"
                      }, null, 8, ["onAttach"])
                    ])
                  ]),
                  _: 1
                }, 8, ["onAttach"]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('common.no_data', 'f')), 1)
                ], 64))
          ]))
        : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.module.loading || _ctx.module.appending)
        ? (_openBlock(), _createBlock(_component_NLoadingCircle, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_InfiniteScroll, {
      filters: _ctx.module.filter.current,
      onLoadMore: _cache[5] || (_cache[5] = ($event: any) => (_ctx.module.append()))
    }, null, 8, ["filters"])
  ]))
}